import SlsTracker from "@aliyun-sls/web-track-browser";
import { getMobileTokenInfo } from "@/api/common.module";
import * as jsbridge from "@/utils/jsbridge";
let tracker = null;

export async function init() {
  const { data } = await getMobileTokenInfo();
  const opts = {
    host: `cn-beijing.log.aliyuncs.com`, // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
    project: data.project, // Project名称。
    logstore: data.logstore_web, // Logstore名称。
    time: 10, // 发送日志的时间间隔，默认是10秒。
    count: 10, // 发送日志的数量大小，默认是10条。
    topic: "xj-activity-2023", // 自定义日志主题。
    source: "source",
    tags: {
      tags: "tags",
    },
  };
  tracker = new SlsTracker(opts);
}

export function sendInfo(err, info) {
  if (tracker) {
    const { id: uid } = jsbridge.getNativeUserInfo();
    const { version } = jsbridge.getSystemInfo();
    tracker.send({
      msg: err || {},
      info: info || {},
      url: location.href,
      // tag: '',
      uid: uid,
      version: version,
    });
    console.log("err+info", err.message, info);
  } else {
    init();
  }
}
